module.exports = __webpack_public_path__ + "static/media/serranasMargaritas.7dd4b754.webp";